/**
 * Tenders route.
 */
import React, { lazy } from 'react';

import { Route } from 'react-router-dom';

const Tender = lazy(() => import('./Tender'));

const TenderRoute = <Route key="tender" path="tender" element={<Tender />} />;

export default TenderRoute;
